import { render, staticRenderFns } from "./MaterialCategoryModal.vue?vue&type=template&id=c54ee488&scoped=true"
import script from "./MaterialCategoryModal.vue?vue&type=script&lang=js"
export * from "./MaterialCategoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c54ee488",
  null
  
)

export default component.exports